module.exports = __webpack_public_path__ + "img/ic_foot_hight_9.c8a0aa5b.png";